import {
  GET_APPOINTMENTS,
  GET_APPOINTMENT_SETTINGS,
  GET_STATUSES,
  GET_INSTRUCTOR_AVAILABILITY,
  ADD_APPOINTMENT,
  EDIT_APPOINTMENT,
  DELETE_APPOINTMENT,
  SORT_APPOINTMENTS,
  FILTER_APPOINTMENTS,
  SET_CURRENT_APPOINTMENT,
  CLEAR_CURRENT_APPOINTMENT,
  SET_SCHEDULE_LOADING,
  SCHEDULE_MODAL_CONTROL,
  SET_ERRORS,
  CLEAR_ERRORS,
  LOGOUT,
} from "../actions/types";

const decrementScheduleLoading = (state) => {
  const loadingRequests = Math.max(state.loadingRequests - 1, 0);

  return {
    loadingRequests,
    scheduleLoading: loadingRequests > 0,
  };
};

const initialState = {
  appointments: [],
  statuses: [],
  sortedAppointments: [],
  currentAppointment: {
    instructorID: "",
    date: null,
    time: "",
    session: null,
    pickupLocation: {
      streetAddress: "",
      city: "",
      province: "",
      postalCode: "",
    },
    publicNotes: "",
    privateNotes: "",
    status: "",
  },
  settings: {},
  scheduleErrors: null,
  message: null,
  scheduleLoading: false,
  loadingRequests: 0,
};

const scheduleReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_APPOINTMENTS: {
      const { loadingRequests, scheduleLoading } =
        decrementScheduleLoading(state);

      return {
        ...state,
        appointments: action.payload,
        loadingRequests,
        scheduleLoading,
      };
    }
    case GET_APPOINTMENT_SETTINGS: {
      const { loadingRequests, scheduleLoading } =
        decrementScheduleLoading(state);

      return {
        ...state,
        settings: { ...state.settings, ...action.payload },
        loadingRequests,
        scheduleLoading,
      };
    }
    case GET_INSTRUCTOR_AVAILABILITY: {
      const { loadingRequests, scheduleLoading } =
        decrementScheduleLoading(state);

      return {
        ...state,
        settings: { ...state.settings, instructorAvailability: action.payload },
        loadingRequests,
        scheduleLoading,
      };
    }

    case GET_STATUSES: {
      const { loadingRequests, scheduleLoading } =
        decrementScheduleLoading(state);

      return {
        ...state,
        statuses: action.payload,
        loadingRequests,
        scheduleLoading,
      };
    }
    case ADD_APPOINTMENT: {
      const { loadingRequests, scheduleLoading } =
        decrementScheduleLoading(state);

      return {
        ...state,
        appointments: action.payload,
        loadingRequests,
        scheduleLoading,
      };
    }
    case EDIT_APPOINTMENT: {
      const { loadingRequests, scheduleLoading } =
        decrementScheduleLoading(state);

      return {
        ...state,
        appointments: state.appointments.map((appointment) =>
          appointment._id === action.payload._id
            ? { ...action.payload, current: true }
            : appointment
        ),
        loadingRequests,
        scheduleLoading,
      };
    }
    case DELETE_APPOINTMENT: {
      const { loadingRequests, scheduleLoading } =
        decrementScheduleLoading(state);

      return {
        ...state,
        appointments: state.appointments.filter(
          (appointment) => appointment._id !== action.payload._id
        ),
        loadingRequests,
        scheduleLoading,
      };
    }
    case SORT_APPOINTMENTS: {
      const { loadingRequests, scheduleLoading } =
        decrementScheduleLoading(state);

      return {
        ...state,
        sortedAppointments: state.appointments.sort(
          (a, b) => a[action.payload] - b[action.payload]
        ),
        loadingRequests,
        scheduleLoading,
      };
    }
    case FILTER_APPOINTMENTS: {
      const { loadingRequests, scheduleLoading } =
        decrementScheduleLoading(state);

      return {
        ...state,

        //Not quite right, need to filter based on the object values instead
        filteredAppointments: state.appointments.filter((appointment) =>
          appointment.contains(action.payload)
        ),
        loadingRequests,
        scheduleLoading,
      };
    }
    case SET_CURRENT_APPOINTMENT: {
      const { loadingRequests, scheduleLoading } =
        decrementScheduleLoading(state);

      return {
        ...state,
        currentAppointment: { ...state.currentAppointment, ...action.payload },
        loadingRequests,
        scheduleLoading,
      };
    }
    case CLEAR_CURRENT_APPOINTMENT: {
      const { loadingRequests, scheduleLoading } =
        decrementScheduleLoading(state);

      return {
        ...state,
        currentAppointment: null,
        loadingRequests,
        scheduleLoading,
      };
    }
    case SCHEDULE_MODAL_CONTROL: {
      const { loadingRequests, scheduleLoading } =
        decrementScheduleLoading(state);

      return {
        ...state,
        openScheduleModal: !state.openScheduleModal,
        loadingRequests,
        scheduleLoading,
      };
    }
    case SET_SCHEDULE_LOADING:
      return {
        ...state,
        scheduleLoading: true,
        loadingRequests: state.loadingRequests + 1,
      };

    case SET_ERRORS: {
      const { loadingRequests, scheduleLoading } =
        decrementScheduleLoading(state);

      return {
        ...state,
        errors: action.payload,
        loadingRequests,
        scheduleLoading,
      };
    }

    case CLEAR_ERRORS:
      return {
        ...state,
        errors: null,
      };

    case LOGOUT:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default scheduleReducer;
